import { isNil } from 'ramda'

import type { LinkUrl } from '@twisto/api-cms'

// Extract url from page reference if exists
export const getLinkUrl = (link: LinkUrl): string | undefined => {
  if (isNil(link)) {
    return link
  }

  if (!isNil(link.page)) {
    return link.page.path
  }

  if (!isNil(link.category)) {
    return link.category.path ?? ''
  }

  if (!isNil(link.article)) {
    return link.article.path ?? ''
  }

  if (!isNil(link.url)) {
    return link.url
  }

  return ''
}
